import React from "react";
import PropTypes from "prop-types";
import Footer from "../components/Footer";
import LoadingScreen from "../components/blocks/LoadingScreen";
import { ThemeProvider } from "styled-components";
import theme from "../styles/theme";
import { compose, withState, lifecycle } from "recompose";

import "../styles/main.css";

const PAGE_LOADED = "PAGE_LOADED";
const FIRE_WHEN_READY = "FIRE_WHEN_READY";

const enhance = compose(
  withState("loadingTarget", "onLoadingTargetChange", false),
  lifecycle({
    componentWillMount() {
      if (typeof document !== "undefined") require("../rollbar");
    },
    componentWillReceiveProps(nextProps) {
      const { loadingTarget, onLoadingTargetChange } = nextProps;

      if (
        nextProps.location.pathname !== this.props.location.pathname &&
        !loadingTarget
      ) {
        debugger;
        onLoadingTargetChange(nextProps.location.pathname);
        window.scrollTo(0, 0);
        setTimeout(() => {
          if (loadingTarget === FIRE_WHEN_READY) onLoadingTargetChange(null);
          else onLoadingTargetChange(PAGE_LOADED);
        }, 750);
      }

      if (
        nextProps.location.pathname === this.props.location.pathname &&
        loadingTarget &&
        (loadingTarget === PAGE_LOADED || loadingTarget !== FIRE_WHEN_READY)
      ) {
        if (loadingTarget === PAGE_LOADED) {
          onLoadingTargetChange(null);
        } else {
          onLoadingTargetChange(FIRE_WHEN_READY);
        }
      }
    }
  })
);

const Template = ({ loadingTarget = "/", children }) =>
  <ThemeProvider theme={theme}>
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        {children()}
      </div>
      <Footer />
      <LoadingScreen loading={!!loadingTarget} />
    </div>
  </ThemeProvider>;

export default enhance(Template);



// WEBPACK FOOTER //
// ./src/layouts/index.js